import { useEffect } from 'react';

export const useExtensionFullScreen = (isPlugin, editorRef) => {
  useEffect(() => {

  }, [isPlugin, editorRef]);
}